import { render, staticRenderFns } from "./CompleteResetPwd.vue?vue&type=template&id=50c744cc&scoped=true&"
import script from "./CompleteResetPwd.vue?vue&type=script&lang=js&"
export * from "./CompleteResetPwd.vue?vue&type=script&lang=js&"
import style0 from "./CompleteResetPwd.vue?vue&type=style&index=0&id=50c744cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c744cc",
  null
  
)

export default component.exports